import { render } from "./IconStats.vue?vue&type=template&id=499f732c&ts=true"
import script from "./IconStats.vue?vue&type=script&lang=ts"
export * from "./IconStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__